import axiosInstance from "@/services/axiosInterceptor";

export async function updateFile(id, body) {
  try {
    const response = await axiosInstance.put(`users/files/${id}`, body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    const data = response?.data;
    return data;
  } catch (error) {
    throw error;
  }
}
